{
  "dashboard": {
    "actuatorsModal": {
      "title": "Ovládání zařízení",
      "tabAll": "Všechny",
      "tabActive": "Aktivní ({{count}})",
      "tabFavorites": "Oblíbené",
      "tabTestMode": "Testovací režim",
      "diagnosticMode": "Diagnostický režim",
      "diagnosticDescription": "Spusťte průvodce testováním pro plynulé ověření komunikace hardwaru (včetně zátěžových PWM kroků).",
      "startTestWizard": "Spustit průvodce testováním",
      "noActiveItems": "Žádné aktivní prvky.",
      "noItemsToShow": "Žádné prvky k zobrazení."
    },
    "reservoir": {
      "tank": "Nádrž",
      "noTankAssigned": "Žádná nádrž není přiřazena k tomuto zařízení",
      "manageTanks": "Spravovat nádrže",
      "goToTanks": "Přejít na správu nádrží",
      "defaultTankName": "Hlavní nádrž"
    },
    "weather": {
      "title": "Počasí",
      "loadingWeather": "Načítám počasí...",
      "geolocationNotSupported": "Geolokace neni podporovana",
      "failedToLoad": "Nepodařilo se načíst počasí",
      "locationDenied": "Poloha nebyla povolena",
      "feelsLike": "Pocitová",
      "humidity": "Vlhkost",
      "wind": "Vítr",
      "pressure": "Tlak",
      "alertTitle": "Výstraha z OpenWeather",
      "forecastTitle": "Předpověď na 3 dny",
      "dayPlus": "+{{num}} den"
    },
    "gardenOverview": {
      "title": "Aktivní pěstování",
      "allAreas": "Všechny záhony",
      "currentlyGrowing": "Právě roste",
      "plans": "plánů",
      "areaUsage": "Využití ploch",
      "yourPlants": "Vaše rostliny",
      "area": "Záhon: {{name}}",
      "areaUnknown": "Neznámý",
      "nothingGrowingYet": "Zatím nic nepěstujete. Založte si první výsadbu!",
      "emptyAreasAvailable": "K dispozici máte dalších {{count}} volných záhonů."
    },
    "sensorCard": {
      "sensorLabel": "ČIDLO",
      "sensorTypeLabel": "{{type}} ČIDLO",
      "statusWorking": "Funguje",
      "statusWarning": "Varování",
      "statusError": "Chyba",
      "statusOffline": "Nepřipojeno",
      "okStatus": "V POŘÁDKU",
      "attentionStatus": "POZOR",
      "calibration": "Seřízení",
      "troubleshootingTitle": "Co zkusit:",
      "troubleshootingTip1": "Zkontrolujte kabeláž a napájení čidla",
      "troubleshootingTip2": "Ověřte WiFi připojení zařízení",
      "troubleshootingTip3": "Restartujte řídicí jednotku (ESP32)",
      "phTooltip": "Kyselost vody. Ideálně 5.5 - 6.5",
      "ecTooltip": "Síla výživy. Typicky 1.0 - 2.5 mS/cm",
      "ecDisplayTitle": "Síla výživy"
    },
    "notifications": {
      "title": "Notification Manager",
      "pushNotAllowed": "Push notifikace nejsou povoleny. Zapněte je pro příjem upozornění v reálném čase.",
      "pushNotifications": "Push notifikace",
      "pushDescription": "Upozornění v prohlížeči při kritických stavech",
      "emailNotifications": "Email Notifications",
      "emailDescription": "Send alerts via email",
      "soundNotifications": "Sound Notifications",
      "soundDescription": "Play sound (needs user interaction)",
      "channels": "Channels",
      "contactInfo": "Contact Information",
      "emailAddress": "Email Address",
      "phoneNumber": "Phone Number",
      "volume": "Volume",
      "quietHours": "Quiet Hours",
      "startTime": "Start Time",
      "endTime": "End Time",
      "enabled": "Enabled",
      "tabRules": "Rules",
      "tabHistory": "History",
      "tabSettings": "Settings",
      "notificationRules": "Notification Rules",
      "addRule": "Add Rule",
      "notificationHistory": "Notification History",
      "noNotifications": "No notifications yet",
      "notificationsAppearHere": "Notifications will appear here when triggered by your rules",
      "notificationSettings": "Notification Settings"
    },
    "quickActions": {
      "title": "Quick Actions",
      "confirmAction": "Opravdu chcete provést akci \"{{title}}\"?",
      "executeAction": "Provést"
    },
    "sidebar": {
      "controls": "Ovládání",
      "sectionActive": "Aktivní",
      "noActiveDevices": "Žádná aktivní zařízení",
      "sectionFavorites": "Oblíbené",
      "noFavorites": "Žádné oblíbené",
      "addFavoritesHint": "Přidejte si oblíbené v sekci Ovládání",
      "sectionTestMode": "Testovací režim",
      "startDiagnostics": "Spustit diagnostiku",
      "viewAll": "Zobrazit vše",
      "devicesCount": "{{count}} zařízení",
      "openControls": "Otevřít ovládání",
      "errorToggling": "Chyba při přepínání zařízení",
      "emergencyDone": "Nouzové zastavení provedeno!",
      "emergencyError": "Chyba při nouzovém zastavení",
      "emergencyReset": "Nouzový stav zrušen, provoz obnoven.",
      "emergencyResetError": "Chyba při rušení nouzového stavu",
      "active": "aktivní",
      "stateError": "Chyba"
    },
    "sensorDetail": {
      "tabOverview": "Přehled",
      "tabHistory": "Historie",
      "tabCalibration": "Seřízení",
      "tabConfig": "Nastavení",
      "idealRange": "Ideální rozsah",
      "minimum": "Minimum",
      "maximum": "Maximum",
      "average": "Průměr",
      "median": "Medián",
      "sensorOffline": "Čidlo je offline",
      "calibrateSensor": "Seřídit čidlo",
      "historyTitle": "Vývoj hodnoty (7 dní)",
      "lastCalibration": "Poslední seřízení",
      "never": "Nikdy",
      "offlineCalibrationBlocked": "Čidlo je offline, seřízení není možné",
      "troubleshootingTitle": "Co zkusit:",
      "troubleshootingTip1": "Zkontrolujte kabeláž a napájení čidla",
      "troubleshootingTip2": "Ověřte WiFi připojení zařízení",
      "troubleshootingTip3": "Restartujte řídicí jednotku (ESP32)",
      "startNewCalibration": "Spustit nové seřízení",
      "calibrationHistory": "Historie seřízení",
      "twoPointCalibration": "2-bodové seřízení",
      "noCalibrationHistory": "Žádná historie seřízení",
      "generalSection": "Obecné",
      "sensorName": "Název čidla",
      "activeLabel": "Aktivní",
      "limitsAndAlarms": "Limity a Alarmy",
      "managedByCycle": "Řízeno cyklem: {{name}}",
      "recipeRecommended": "Hodnoty jsou doporučeny receptem ({{phase}}).",
      "noActiveCycleTitle": "Žádný aktivní cyklus",
      "noActiveCycleDesc": "Pro automatické řízení musíte mít aktivní pěstební cyklus.",
      "createNewCycle": "Založit nový cyklus",
      "managedByRecipe": "Řízeno Receptem",
      "manualLimits": "Manuální Limity",
      "allowedRange": "Rozsah povolených hodnot (Alarm)",
      "minLimit": "Min Limit",
      "maxLimit": "Max Limit",
      "targetValue": "Cílová hodnota (Ideál)",
      "targetUsedForCharts": "Používá se pro výpočet odchylky v grafech.",
      "calibrationSection": "Seřízení",
      "probeQuality": "Kvalita sondy",
      "unknown": "Neznámo",
      "slope": "Směrnice (Slope)",
      "automationSection": "Automatická péče",
      "noAutomationRules": "Žádná pravidla automatické péče nevyužívají toto čidlo.",
      "createRule": "Vytvořit pravidlo",
      "editRule": "Upravit pravidlo",
      "saveSettings": "Uložit nastavení",
      "noHistoryTitle": "Zatím nejsou naměřená data",
      "noHistoryDesc": "Historie se zobrazí, jakmile čidlo nasbírá měření."
    },
    "sensorConfigPanel": {
      "loading": "Načítám konfiguraci čidla...",
      "readOnly": "Pouze pro čtení",
      "active": "Aktivní",
      "inactive": "Neaktivní",
      "unitHint": {
        "unit": "Jednotka: {{unit}}",
        "range": "(Rozsah: {{min}} - {{max}})",
        "unitAndRange": "Jednotka: {{unit}} (Rozsah: {{min}} - {{max}})",
        "rangeOnly": "Rozsah: {{min}} - {{max}}"
      },
      "threshold": "Prahová hodnota:",
      "notification": "Upozornění",
      "calibratedAt": "Seřízeno:",
      "notes": "Poznámky:",
      "recalibrate": "Seřídit znovu",
      "warningsTitle": "Varování",
      "saving": "Ukládám...",
      "saveChanges": "Uložit změny",
      "saveParamTitle": "Uložit parametr {{name}}",
      "tabs": {
        "parameters": "Parametry ({{count}})",
        "alerts": "Alerty ({{count}})",
        "calibrations": "Seřízení ({{count}})"
      },
      "toasts": {
        "paramUpdated": "Parametr aktualizován",
        "paramUpdateFailed": "Chyba při aktualizaci: {{message}}",
        "apiError": "Chyba komunikace s API",
        "bulkUpdated": "Parametry hromadně aktualizovány",
        "bulkFailed": "Chyba: {{message}}",
        "bulkApiError": "Chyba komunikace při hromadné aktualizaci",
        "exportFailed": "Nelze exportovat konfiguraci",
        "loadFailed": "Nepodařilo se načíst konfiguraci čidla"
      }
    },
    "todayTasks": {
      "title": "Dnešní úkoly",
      "addTask": "Přidat úkol",
      "viewAll": "Zobrazit vše",
      "allDone": "Vše hotovo!",
      "noMoreTasks": "Na dnešek nemáš žádné další úkoly.",
      "completeTask": "Splnit úkol",
      "priority": "Priorita"
    },
    "branchManager": {
      "title": "Pěstební Větve",
      "addBranch": "Přidat větev",
      "loading": "Načítání větví...",
      "statusActive": "Aktivní",
      "statusInactive": "Neaktivní",
      "editAriaLabel": "Upravit větev",
      "deleteAriaLabel": "Smazat větev",
      "noBranches": "Zatím žádné definované větve",
      "closeAriaLabel": "Zavřít formulář",
      "formEditTitle": "Upravit větev",
      "formCreateTitle": "Nová pěstební větev",
      "nameLabel": "Název větve",
      "namePlaceholder": "např. Levá strana",
      "hwIndexLabel": "Hardwarový index (1-4)",
      "hwOutput": "Výstup {{index}}",
      "hwHint": "Odpovídá fyzickému zapojení na kontroleru.",
      "descriptionLabel": "Popis (volitelné)",
      "activeLabel": "Větev je aktivní",
      "saveChanges": "Uložit změny",
      "createBranch": "Vytvořit větev",
      "delete": {
        "title": "Smazat větev?",
        "description": "Opravdu chcete smazat tuto pěstební větev? Tato akce je nevratná.",
        "confirmText": "Smazat",
        "cancelText": "Zrušit"
      },
      "toasts": {
        "created": "Větev vytvořena",
        "createFailed": "Chyba při vytváření větve",
        "updated": "Větev aktualizována",
        "updateFailed": "Chyba při úpravě větve",
        "deleted": "Větev smazána",
        "deleteFailed": "Chyba při mazání větve"
      }
    }
  },
  "alertManager": {
    "title": "Správa alertů",
    "subtitle": "Zobrazení, potvrzování a správa systémových alertů",
    "filtered": "Filtrováno",
    "resolvedHint": "(Zobrazeny vyřešené - max 20 dní)",
    "statCards": {
      "total": "Celkem alertů",
      "active": "Aktivní",
      "critical": "Kritické",
      "high": "Vysoké priority",
      "resolved": "Vyřešené",
      "companionSuggestions": "Návrhy sousedů"
    },
    "filter": {
      "all": "Všechny",
      "active": "Aktivní",
      "acknowledged": "Potvrzené",
      "resolved": "Vyřešené"
    },
    "actions": {
      "refresh": "Obnovit",
      "archive": "Archivovat",
      "archiveTitle": "Archivovat staré vyřešené alerty (starší 20 dní)"
    },
    "bulk": {
      "selected": "Vybráno {{count}} alertů",
      "acknowledge": "Potvrdit",
      "resolve": "Vyřešit"
    },
    "table": {
      "selectAll": "Vybrat všechny alerty",
      "selectAlert": "Vybrat alert {{id}}",
      "colType": "Typ",
      "colSeverity": "Závažnost",
      "colMessage": "Zpráva",
      "colSensor": "Čidlo",
      "colCreated": "Vytvořeno",
      "colStatus": "Status",
      "colResolved": "Vyřešeno",
      "colResolvedBy": "Vyřešil",
      "colActions": "Akce",
      "viewDetail": "Zobrazit detail",
      "acknowledgeAlert": "Potvrdit alert",
      "resolveAlert": "Vyřešit alert"
    },
    "status": {
      "resolved": "Vyřešeno",
      "acknowledged": "Potvrzeno",
      "pending": "Čeká"
    },
    "empty": {
      "active": "Žádné aktivní alerty",
      "acknowledged": "Žádné potvrzené alerty",
      "resolved": "Žádné vyřešené alerty (posledních 20 dní)",
      "critical": "Žádné kritické alerty",
      "high": "Žádné alerty vysoké priority",
      "default": "Žádné alerty nebyly nalezeny"
    },
    "pagination": {
      "showing": "{{from}}-{{to}} z {{total}} upozornění",
      "previous": "← Předchozí",
      "next": "Další →"
    },
    "detail": {
      "closeTitle": "Zavřít detail alertu",
      "severity": {
        "critical": "Kritické",
        "high": "Vysoká priorita"
      },
      "difficulty": "Obtížnost: {{text}}",
      "time": "Čas: {{time}}",
      "physicalAccess": "Vyžaduje fyzický přístup",
      "message": "Zpráva",
      "resolvedInfo": "Vyřešeno",
      "resolvedDate": "Datum:",
      "resolvedBy": "Vyřešil:",
      "notProvided": "Neuvedeno",
      "device": "Zařízení",
      "problemDescription": "Popis problému",
      "solutionSteps": "Návod k řešení",
      "availableActions": "Dostupné akce",
      "viewLogs": "Zobrazit systémové logy",
      "close": "Zavřít",
      "acknowledge": "Potvrdit",
      "resolve": "Vyřešit"
    },
    "archive": {
      "title": "Archivovat staré alerty",
      "description": "Opravdu chcete přesunout do archivu všechny vyřešené alerty starší než 20 dní? Archivované alerty budou dostupné v historii, ale nebudou se zobrazovat v hlavním přehledu.",
      "cancel": "Zrušit",
      "confirm": "Archivovat",
      "inProgress": "Archivuji..."
    },
    "typeLabels": {
      "ph_high": "pH vysoké",
      "ph_low": "pH nízké",
      "ec_high": "EC vysoké",
      "ec_low": "EC nízké",
      "temp_high": "Teplota vysoká",
      "temp_low": "Teplota nízká",
      "system_error": "Chyba systému",
      "network_error": "Chyba sítě",
      "pump_failure": "Porucha čerpadla",
      "sensor_failure": "Porucha čidla",
      "companion_suggestion": "Návrh sousedů (G-Root)"
    },
    "difficulty": {
      "easy": "Jednoduché",
      "medium": "Střední",
      "hard": "Složité"
    },
    "resolvedBy": {
      "unknown": "Neznámé",
      "auto": "Automaticky (systém)",
      "admin": "Admin: {{name}}",
      "user": "Uživatel: {{name}}",
      "userId": "Uživatel #{{id}}"
    },
    "companion": {
      "speciesA": "Rostlina A",
      "speciesB": "Rostlina B"
    },
    "errors": {
      "noDeviceId": "Nelze restartovat: Chybí ID zařízení",
      "approveError": "Chyba při schvalování vazby",
      "rejectError": "Chyba při zamítání vazby"
    },
    "toasts": {
      "approved": "Vazba {{a}} + {{b}} schválena",
      "rejected": "Vazba {{a}} + {{b}} zamítnuta"
    },
    "solutionActions": {
      "calibratePh": "Spustit seřízení",
      "restartPh": "Restart pH čidla",
      "calibrateEc": "Seřízení EC",
      "testDoser": "Test dávkovače",
      "addNutrients": "Přidat živiny",
      "restartFans": "Restart ventilátorů",
      "testCooling": "Test chlazení",
      "restartHeating": "Restart topení",
      "testThermostat": "Test termostatu",
      "restartApi": "Restart API",
      "restartDevice": "Restart zařízení",
      "testConnection": "Test připojení",
      "restartMqtt": "Restart MQTT",
      "restartPump": "Restart čerpadla",
      "testRelay": "Test relé",
      "replacePump": "Výměna čerpadla",
      "calibrateSensor": "Seřízení čidla",
      "restartSensor": "Restart čidla",
      "replaceSensor": "Výměna čidla",
      "approveCompanion": "Schválit vazbu",
      "rejectCompanion": "Zamítnout",
      "viewDetail": "Detail rostliny"
    },
    "solutions": {
      "ph_high": {
        "description": "Hodnota pH je příliš vysoká. Může to být způsobeno špatným seřízením čidla, znečištěním sondy nebo skutečně vysokým pH roztoku.",
        "steps": [
          "Zkontrolujte, zda je pH sonda čistá a správně ponořená",
          "Ověřte seřízení pomocí referenčního roztoku",
          "Přidejte pH- roztok pro snížení pH",
          "Počkejte 15-30 minut na stabilizaci"
        ],
        "time": "15-30 minut"
      },
      "ph_low": {
        "description": "Hodnota pH je příliš nízká. Může to být způsobeno překyselením roztoku nebo chybou čidla.",
        "steps": [
          "Zkontrolujte stav pH sondy",
          "Ověřte seřízení",
          "Přidejte pH+ roztok pro zvýšení pH",
          "Sledujte stabilizaci hodnot"
        ],
        "time": "15-30 minut"
      },
      "ec_high": {
        "description": "Hodnota EC (vodivosti) je příliš vysoká. Roztok obsahuje příliš mnoho živin.",
        "steps": [
          "Zřeďte roztok čistou vodou",
          "Zkontrolujte dávkovací systém",
          "Ověřte stav EC sondy",
          "Sledujte hodnoty po úpravě"
        ],
        "time": "20-40 minut"
      },
      "ec_low": {
        "description": "Hodnota EC (vodivosti) je příliš nízká. Roztok obsahuje málo živin.",
        "steps": [
          "Přidejte živiny podle receptury",
          "Zkontrolujte dávkovací systém",
          "Ověřte stav EC sondy",
          "Počkejte na promíchání"
        ],
        "time": "15-25 minut"
      },
      "temp_high": {
        "description": "Teplota roztoku nebo prostředí je příliš vysoká. Může poškodit kořeny rostlin.",
        "steps": [
          "Zkontrolujte ventilaci a chlazení",
          "Ověřte funkčnost ventilátorů",
          "Přidejte chladící prvky do nádrže",
          "Snižte teplotu okolí"
        ],
        "time": "30-60 minut"
      },
      "temp_low": {
        "description": "Teplota je příliš nízká. Může zpomalit růst rostlin.",
        "steps": [
          "Zkontrolujte topné těleso",
          "Ověřte nastavení termostatu",
          "Izolujte nádrž",
          "Zvyšte teplotu okolí"
        ],
        "time": "20-40 minut"
      },
      "system_error": {
        "description": "Došlo k systémové chybě. Může být způsobena softwarovým problémem nebo chybou komunikace.",
        "steps": [
          "Zkontrolujte logy systému",
          "Ověřte stav připojení k síti",
          "Restartujte problematickou službu",
          "Pokud přetrvává, restartujte zařízení"
        ],
        "time": "5-15 minut"
      },
      "network_error": {
        "description": "Chyba síťového připojení. Zařízení nemá stabilní spojení se serverem.",
        "steps": [
          "Zkontrolujte WiFi signál",
          "Ověřte stav routeru",
          "Zkontrolujte MQTT broker",
          "Restartujte síťové připojení"
        ],
        "time": "5-20 minut"
      },
      "pump_failure": {
        "description": "Čerpadlo nefunguje správně. Může být ucpané, poškozené nebo mít elektrický problém.",
        "steps": [
          "Zkontrolujte napájení čerpadla",
          "Ověřte, zda není ucpané",
          "Zkontrolujte relé a spínač",
          "Otestujte čerpadlo manuálně"
        ],
        "time": "15-60 minut"
      },
      "sensor_failure": {
        "description": "Čidlo nevrací platná data. Může být porušené, špatně připojené nebo potřebuje seřízení.",
        "steps": [
          "Zkontrolujte kabeláž čidla",
          "Vyčistěte čidlo",
          "Proveďte seřízení",
          "Pokud přetrvává, vyměňte čidlo"
        ],
        "time": "20-45 minut"
      },
      "companion_suggestion": {
        "description": "G-Root AI objevil novou potenciální vazbu mezi dvěma rostlinami na základě analýzy znalostního grafu. Zkontrolujte detail a případně potvrďte nebo zamítněte.",
        "steps": [
          "Prostudujte biologické efekty navržené vazby",
          "Ověřte, zda výsledek odpovídá vašim zkušenostem",
          "Potvrďte vazbu (přidá se do ověřených vztahů) nebo zamítněte"
        ],
        "time": "1-2 minuty"
      },
      "default": {
        "description": "Nastala neočekávaná chyba. Zkontrolujte systém a logy pro více informací.",
        "steps": [
          "Zkontrolujte systémové logy",
          "Ověřte stav všech komponent",
          "Restartujte problematické služby",
          "Kontaktujte podporu pokud problém přetrvává"
        ],
        "time": "10-30 minut"
      }
    }
  },
  "onboarding": {
    "steps": {
      "intro": "Rootify",
      "welcome": "Vítejte",
      "place": "Místo",
      "method": "Styl",
      "plants": "Rostliny",
      "reservoir": "Nádrž",
      "area": "Záhon",
      "complete": "Hotovo"
    },
    "nav": {
      "back": "Zpět",
      "skip": "Přeskočit průvodce",
      "next": "Další",
      "submitting": "Vytvářím...",
      "finalize": "Dokončit nastavení",
      "goBack": "Zpět na: {{title}}"
    },
    "defaults": {
      "areaName": "Záhon 1",
      "reservoirName": "Hlavní nádrž"
    },
    "toasts": {
      "success": "Vše je připraveno! Můžete začít pěstovat.",
      "error": "Chyba při vytváření: {{message}}",
      "errorFallback": "Zkuste to znovu"
    },
    "intro": {
      "subtitle": "Váš osobní zahradnický asistent pro chytré pěstování",
      "start": "Pojďme na to!",
      "benefits": {
        "growth": {
          "title": "Sledujte růst",
          "desc": "Přehledný deník a statistiky vašich rostlin"
        },
        "fertilize": {
          "title": "Automatické hnojení",
          "desc": "Systém dávkuje živinové látky za vás"
        },
        "monitor": {
          "title": "Nechte to na nás",
          "desc": "Upozornění a hlídání parametrů 24/7"
        }
      }
    },
    "welcome": {
      "title": "Vítejte v Rootify!",
      "desc": "Za pár minut vám pomůžeme nastavit vaše pěstování. Zjistíme, jak a kde pěstujete, a připravíme vám vše na míru."
    },
    "place": {
      "title": "Kde pěstujete?",
      "subtitle": "Vyberte všechna místa — můžete jich zvolit více",
      "customNames": "Chcete si svá místa pojmenovat?",
      "empty": "Vyberte alespoň jedno místo pro pokračování",
      "nameAriaLabel": "Název pro {{name}}",
      "options": {
        "windowsill": {
          "label": "Na parapetu",
          "desc": "Bylinky, malé rostliny"
        },
        "indoor_tent": {
          "label": "Grow stan",
          "desc": "Umělé osvětlení, řízené podmínky"
        },
        "garden": {
          "label": "Zahrádka",
          "desc": "Venkovní záhon či terasa"
        },
        "community": {
          "label": "Komunitní zahrada",
          "desc": "Sdílený prostor"
        },
        "greenhouse": {
          "label": "Skleník",
          "desc": "Krytý prostor s přirozeným světlem"
        }
      }
    },
    "method": {
      "title": "Jak pěstujete?",
      "subtitle": "Vyberte všechny metody — můžete kombinovat",
      "empty": "Vyberte alespoň jednu metodu pro pokračování",
      "options": {
        "hydroponic": {
          "label": "Hydroponicky",
          "desc": "Pěstování bez půdy v živinovém roztoku",
          "features": "pH / EC monitoring · Automatické dávkování · Nádrž s roztokem"
        },
        "soil": {
          "label": "Klasicky (v půdě)",
          "desc": "Tradiční pěstování v substrátu",
          "features": "Vlhkost půdy · Teplota prostředí · Zavlažování"
        },
        "aquaponic": {
          "label": "Akvaponicky",
          "desc": "Symbióza ryb a rostlin v uzavřeném systému",
          "features": "Akvárium + rostliny · pH / teplota vody · Krmení ryb"
        }
      }
    },
    "plants": {
      "title": "Co chcete pěstovat?",
      "subtitle": "Vyberte rostliny, které vás zajímají — pomůžeme vám s nastavením",
      "empty": "Nepovinné — můžete přeskočit",
      "selected_one": "Vybrana: {{count}} rostlina",
      "selected_few": "Vybrano: {{count}} rostliny",
      "selected_many": "Vybrano: {{count}} rostlin",
      "options": {
        "lettuce": "Salát",
        "basil": "Bazalka",
        "tomato": "Rajče",
        "pepper": "Paprika",
        "strawberry": "Jahody",
        "cucumber": "Okurky",
        "mint": "Máta",
        "spinach": "Špenát",
        "parsley": "Petržel",
        "chili": "Chilli",
        "herbs": "Bylinky",
        "microgreens": "Mikrozelenina"
      }
    },
    "reservoir": {
      "title": "Nádrž se živinami",
      "subtitle": "Sem doplňujete živinový roztok pro rostliny",
      "nameLabel": "Název nádrže",
      "namePlaceholder": "Např. Hlavní nádrž",
      "volumeLabel": "Objem nádrže",
      "volumeTitle": "Objem nádrže: {{value}} l",
      "hardwareCheckbox": "Vlastníte Rootify hardware?",
      "hardwareDesc": "Připojte řídicí jednotku k nádrži",
      "hardwareConnected": "Hardware bude propojen",
      "hardwareHint": "Připojení nastavíte v sekci Nastavení po dokončení průvodce",
      "sizes": {
        "small": "Malá",
        "medium": "Střední",
        "large": "Velká"
      }
    },
    "area": {
      "title": "Pěstební plocha",
      "subtitle": "Nastavte rozložení rostlin na vašem záhonu",
      "assignLabel": "Přiřadit ke stanovišti",
      "nameLabel": "Název záhonu",
      "namePlaceholder": "Např. Záhon 1",
      "typeLabel": "Typ systému",
      "sizeLabel": "Kolik rostlin chcete pěstovat?",
      "advancedToggle": "Vlastní rozložení (pro pokročilé)",
      "rowsLabel": "Řádky",
      "colsLabel": "Sloupce",
      "slotsCount": "pozic",
      "hiddenSlots": "(-{{count}} skryto)",
      "slotsTotalLabel": "pozic celkem",
      "clickHint": "Kliknutím na čtverečky definujete nepravidelný tvar.",
      "zigzagXHint": "Cik-cak ↔ automaticky zkracuje liché řádky. ",
      "zigzagYHint": "Cik-cak ↕ automaticky zkracuje liché sloupce. ",
      "checkerboardHint": "Šachovnice vynechává každý druhý slot. ",
      "gardenHint": "Záhon bude vytvořen v prvním stanovišti. Další záhony můžete přidat později v sekci Pěstební plochy.",
      "batchToggle": "Rovnou založit výsadbu",
      "hydroTypes": {
        "nft": {
          "label": "NFT",
          "desc": "Živinový roztok teče tenkým filmem přes kořeny. Ideální pro saláty a bylinky."
        },
        "dwc": {
          "label": "DWC",
          "desc": "Kořeny ponořeny přímo v živinovém roztoku s provzdušňováním."
        },
        "drip": {
          "label": "Kapková",
          "desc": "Kapkové zavlažování přímo ke kořenům rostlin."
        },
        "ebb_flow": {
          "label": "Ebb & Flow",
          "desc": "Roztok periodicky zaplavuje kořeny a pak odteče. Jednoduchý a spolehlivý."
        },
        "tower": {
          "label": "Věž",
          "desc": "Vertikální pěstování v patrovém sloupu — šetří místo."
        },
        "aeroponics": {
          "label": "Aero",
          "desc": "Kořeny ve vzduchu, vyživované mlhou živin. Pokročilá metoda."
        }
      },
      "soilTypes": {
        "bed": {
          "label": "Záhon",
          "desc": "Klasický záhon v půdě nebo substrátu."
        },
        "soil": {
          "label": "Květináč",
          "desc": "Půdní květináč pro jednotlivé rostliny."
        },
        "rack": {
          "label": "Regál",
          "desc": "Vícepatrový regál — vertikální zahrada."
        },
        "other": {
          "label": "Jiné",
          "desc": "Vlastní systém."
        }
      },
      "gridSizes": {
        "small": {
          "label": "Malý",
          "desc": "4 pozice"
        },
        "medium": {
          "label": "Střední",
          "desc": "16 pozic"
        },
        "large": {
          "label": "Velký",
          "desc": "30 pozic"
        }
      },
      "layoutTypes": {
        "square": "Mřížka",
        "triangle": "Cik-cak ↔",
        "zigzag_y": "Cik-cak ↕",
        "checkerboard": "Šachovnice"
      }
    },
    "complete": {
      "title": "Vše je připraveno!",
      "placesCreated_one": "Vytvořili jsme {{count}} stanoviště pro {{methods}} pěstování.",
      "placesCreated_few": "Vytvořili jsme {{count}} stanoviště pro {{methods}} pěstování.",
      "placesCreated_many": "Vytvořili jsme {{count}} stanovišť pro {{methods}} pěstování.",
      "addPlants": "Přidejte rostliny a sledujte jejich růst!",
      "settingsHint": "Zařízení, čidla a bezpečnostní pravidla můžete nastavit v Nastavení.",
      "goToDashboard": "Přejít na Dashboard"
    },
    "methodLabels": {
      "hydroponic": "hydroponické",
      "soil": "klasické (v půdě)",
      "aquaponic": "akvaponické"
    }
  },
  "dimmer": {
    "on": "Svítí",
    "off": "Vypnuto",
    "pumpOn": "Aktivní",
    "pumpOff": "Zastaveno",
    "runTimed": "Spustit na čas",
    "turnOn": "Zapnout",
    "turnOff": "Vypnout"
  },
  "actuatorCard": {
    "statusError": "Chyba",
    "statusRunning": "Běží",
    "statusOff": "Vypnuto",
    "locked": "Zamčeno",
    "settings": "Nastavení",
    "history": "Historie",
    "runningPrefix": "Běží: {{duration}}",
    "nextPrefix": "Příští: {{time}}",
    "turnOn": "Zapnout {{name}}",
    "turnOff": "Vypnout {{name}}",
    "timeNow": "Právě teď",
    "timeInMoment": "Za okamžik",
    "timeInMinutes": "Za {{count}} min",
    "timeInHours": "Za {{hours}}h {{minutes}}m",
    "timeInDays": "Za {{count}} dní"
  },
  "sowingWidget": {
    "title": "Nyní vysévat — {{month}}",
    "tempContext": "Venku {{temp}}°C — filtrováno dle teploty",
    "andMore": "+ {{count}} dalších v Plant-O-Pedii"
  },
  "interlockPanel": {
    "title": "Aktivní interlocky",
    "none": "Žádné aktivní ochrany",
    "countBadge_one": "{{count}} ochrana",
    "countBadge_few": "{{count}} pojistky",
    "countBadge_many": "{{count}} ochran",
    "viewAll": "Zobrazit vše",
    "toastFired": "Interlock spuštěn: {{key}}",
    "toastResolved": "Interlock vyřešen: {{key}}",
    "countBadge_other": "{{count}} pojistek"
  },
  "interlockBadge": {
    "blocked": "Zablokováno",
    "tooltipPrefix": "Interlock: "
  },
  "sensorHealthCard": {
    "title": "Zdraví čidel",
    "statusOk": "V pořádku",
    "statusFrozen": "Odpojeno / zmrzlé",
    "statusDrifting": "Drift",
    "statusSaturated": "Saturace",
    "statusStale": "Žádná data",
    "statusNoisy": "Šumivé",
    "statusUnknown": "Neznámý",
    "lastSeen": "Naposledy viděno",
    "stddev": "Odchylka",
    "baselineVoltage": "Ref. napětí",
    "calibrationAge": "Kalibrace před {{days}} dny"
  },
  "sensorConfigPanel": {
    "active": "Aktivní",
    "calibratedAt": "Kalibrováno:",
    "inactive": "Neaktivní",
    "loading": "Načítám nastavení čidla…",
    "notes": "Poznámky:",
    "notification": "Upozornění",
    "readOnly": "Jen pro čtení",
    "recalibrate": "Zkalibrovat znovu",
    "saveChanges": "Uložit změny",
    "saveParamTitle": "Uložit parametr {{name}}",
    "saving": "Ukládám…",
    "tabs": {
      "alerts": "Upozornění ({{count}})",
      "calibrations": "Kalibrace ({{count}})",
      "parameters": "Parametry ({{count}})"
    },
    "threshold": "Mezní hodnota:",
    "toasts": {
      "apiError": "Chyba komunikace se serverem",
      "bulkApiError": "Chyba komunikace při hromadné úpravě",
      "bulkFailed": "Nepodařilo se uložit: {{message}}",
      "bulkUpdated": "Parametry byly hromadně uloženy",
      "exportFailed": "Nastavení se nepodařilo exportovat",
      "loadFailed": "Nastavení čidla se nepodařilo načíst",
      "paramUpdateFailed": "Nepodařilo se uložit: {{message}}",
      "paramUpdated": "Parametr byl uložen"
    },
    "unitHint": {
      "range": "(rozsah {{min}} – {{max}})",
      "rangeOnly": "Rozsah: {{min}} – {{max}}",
      "unit": "Jednotka: {{unit}}",
      "unitAndRange": "Jednotka: {{unit}} (rozsah {{min}} – {{max}})"
    },
    "warningsTitle": "Varování"
  },
  "actions": {
    "skipToContent": "Přeskočit na obsah"
  },
  "nav": {
    "main": "Hlavní navigace",
    "menu": "Menu"
  }
}
